// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"da47b142","156":"a04ffcb7","507":"5213e9de"}[chunkId] + ".chunk.js";
};